import { Skeleton } from '@/components/ui/skeleton';

export default () => {
  return [...new Array(8)].map((_, index) => {
    return (
      <div className="flex items-center text-[12px] h-[72px] border-b-[1px] border-borderColor" key={index}>
        <div className="flex-1">
          <Skeleton className="h-[42px] w-[80%] rounded-xl" />
        </div>
        <div className="flex-1 flex justify-center">
          <Skeleton className="h-[42px] w-[80%] rounded-xl" />
        </div>
        <div className="flex-1 flex justify-end">
          <Skeleton className="h-[42px] w-[80%] rounded-xl" />
        </div>
      </div>
    );
  });
};
